import clsx from 'clsx';
import { FaMagic } from 'react-icons/fa';
import { Button } from '@/components/ui/button';
import { useFlags } from '@/context/feature-flags';

interface BtnGenerateNotesProps {
  connection?: WebSocket | null;
  dataReady?: boolean;
  triggerGeneration?: () => void;
  parentName?: string;
}

export const BtnGenerateNotes = ({
  connection,
  dataReady,
  triggerGeneration,
  parentName,
}: BtnGenerateNotesProps) => {
  const { flags } = useFlags();
  const aiNotesFlag = flags?.['ai-notes'];

  if (!aiNotesFlag) return null;
  if (parentName === 'meeting-tools') return null;

  return (
    <Button
      variant='outline'
      disabled={!connection || !dataReady}
      size='icon-sm'
      onClick={triggerGeneration}
      data-tip={connection ? 'Generate meeting notes' : 'Connecting...'}
    >
      <FaMagic className={clsx('size-3', connection && 'text-green-700 animate-pulse')} />
    </Button>
  );
};
